import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Heart, Mail, Instagram, Youtube } from "lucide-react";
import GooglePlayBadge from "@/components/GooglePlayBadge";

const CONTACT_EMAIL = "naari.livingtech@gmail.com";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-[#4B2E5A]/8 bg-[#FCFAF7]">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-5">
          <div className="col-span-2 md:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/assets/logo.png"
                alt="Naari Sutra"
                className="h-20 w-auto object-contain"
              />
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#4B2E5A]/60">
              Building the AI operating system for everyday life. Simplifying everyday decisions with AI.
            </p>
            <p className="mt-6 text-xs font-semibold uppercase tracking-wider text-[#4B2E5A]/50">
              CookSorted is live
            </p>
            <GooglePlayBadge className="mt-3" height={52} />
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-[#4B2E5A]">Products</h4>
            <ul className="space-y-3 text-sm text-[#4B2E5A]/60">
              <li><Link to="/products/cooksorted" className="hover:text-[#4B2E5A]">CookSorted</Link></li>
              <li><Link to="/products/looksorted" className="hover:text-[#4B2E5A]">LookSorted</Link></li>
              <li><Link to="/products/naari-companion" className="hover:text-[#4B2E5A]">Naari Companion</Link></li>
              <li><Link to="/products/homesorted" className="hover:text-[#4B2E5A]">HomeSorted</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-[#4B2E5A]">Company</h4>
            <ul className="space-y-3 text-sm text-[#4B2E5A]/60">
              <li><Link to="/about" className="hover:text-[#4B2E5A]">About</Link></li>
              <li><Link to="/vision" className="hover:text-[#4B2E5A]">Vision</Link></li>
              <li><Link to="/technology" className="hover:text-[#4B2E5A]">Technology</Link></li>
              <li><Link to="/careers" className="hover:text-[#4B2E5A]">Careers</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-[#4B2E5A]">Follow us on social</h4>
            <div className="flex flex-wrap items-center gap-3">
              <a
                href="https://www.instagram.com/naari.livingtech"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#4B2E5A]/10 bg-white/70 text-[#4B2E5A] transition-colors hover:bg-[#4B2E5A] hover:text-white"
              >
                <Instagram className="h-4 w-4" strokeWidth={1.5} />
              </a>
              <a
                href="https://www.linkedin.com/in/ambalika-smiti/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#4B2E5A]/10 bg-white/70 text-[#4B2E5A] transition-colors hover:bg-[#4B2E5A] hover:text-white"
              >
                <Linkedin className="h-4 w-4" strokeWidth={1.5} />
              </a>
              <a
                href="https://youtube.com/@naari-sutra"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#4B2E5A]/10 bg-white/70 text-[#4B2E5A] transition-colors hover:bg-[#4B2E5A] hover:text-white"
              >
                <Youtube className="h-4 w-4" strokeWidth={1.5} />
              </a>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                aria-label="Email"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#4B2E5A]/10 bg-white/70 text-[#4B2E5A] transition-colors hover:bg-[#4B2E5A] hover:text-white"
              >
                <Mail className="h-4 w-4" strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-[#4B2E5A]/8 pt-8 md:flex-row">
          <p className="text-sm text-[#4B2E5A]/50">© {new Date().getFullYear()} Naari Sutra. All rights reserved.</p>
          <div className="flex items-center gap-6 text-sm text-[#4B2E5A]/50">
            <Link to="/privacy" className="hover:text-[#4B2E5A]">Privacy</Link>
            <Link to="/terms" className="hover:text-[#4B2E5A]">Terms</Link>
            <span className="inline-flex items-center gap-1.5">
              Made with <Heart className="h-4 w-4 fill-[#F28C82] text-[#F28C82]" /> in India
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
